import fetchPost, { fetchGet, fetchPostFormData } from '@/api/http.js'

export default {
  state: {
    "memberId": null,
    "userId": null,
    "tenantId": '',
    "identity": null,
    "telephone": "",
    "userName": "",
    "password": "",
    "state": 1,
    "menuList": [],
    "powerList": [],
    "defaultRoleId": '',
    "defaultRoleName": '',
    "defaultRoleList": [],
    "multiTenantList": [],
    "customerNo": '',
    "status": '',
    "menuMap": null
  },
  getters: {
    status(state) {
      return state.status
    },
    userName(state) {
      return state.userName
    },
    menuList(state) {
      return state.menuList
    },
    defaultRoleId(state) {
      return state.defaultRoleId
    },
    defaultRoleName(state) {
      return state.defaultRoleName
    },
    defaultTenantId(state) {
      return state.tenantId
    },
    defaultRoleList(state) {
      return state.defaultRoleList
    },
    multiTenantList(state) {
      return state.multiTenantList
    },
    menuMap(state) {
      return state.menuMap
    }
  },
  mutations: {
    SAVEINFO(state, data) {
      Object.keys(state).forEach(item => {
        // 除了特定的不需要赋值
        if (!['menuMap'].includes(item)) {
          state[item] = data[item]
        }
        if (item == 'menuList') {
          let menuMap = {};
          data[item].forEach(t => {
            if (t.children.length == 0) return;
            t.children.forEach(i => {
              if (i.children.length == 0) return;
              if (i.children[0].menuType == 1) {
                i.children.forEach(o => {
                  var k = o.menuCode
                  var v = '';
                  o.children.forEach(b => {
                    v += (b.menuCode + '-')
                    if (b.children && b.children.length > 0) {
                      b.children.forEach(btn => {
                        v += (btn.menuCode + '-')
                      })
                    }
                  })
                  menuMap[k] = v.slice(0, -1)
                })
              } else {
                var k = i.menuCode
                var v = '';
                i.children.forEach(o => {
                  v += (o.menuCode + '-')
                  if (o.children && o.children.length > 0) {
                    o.children.forEach(btn => {
                      v += (btn.menuCode + '-')
                    })
                  }
                })
                menuMap[k] = v.slice(0, -1)
              }
            })
          });
          sessionStorage.setItem('menuMap', JSON.stringify(menuMap))
          state.menuMap = menuMap
        }
      });
      sessionStorage.setItem('userInfo', JSON.stringify(state))
      sessionStorage.setItem('username', state.userId || '')
        const userInfo = state
        const deviceData = {
          srcBrowserGuid: window.navigator.userAgent,
          operateUserid: userInfo.userId,
          operateUserBaspRole: userInfo.defaultRoleId
        }
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function(position) {
              var srcDeviceGps = [position.coords.longitude, position.coords.latitude]
              deviceData.srcDeviceGps = srcDeviceGps.join(',')
              // 再次更新deviceData
              window.sessionStorage.setItem('OS_DEVICE_INFO', JSON.stringify(deviceData))
          });
        }
        window.sessionStorage.setItem('OS_DEVICE_INFO', JSON.stringify(deviceData))
      
    },
    SETINFO(state, data) {
      state.status = data.customerDetail.status
    }
  },
  actions: {
    authApi ({ commit }, data) {
      return fetchGet('/upms/auth', data)
    },
    login({ commit }, data) {
      return fetchGet('/upms/login', data)
    },
    getMenu({ commit }) {
      return fetchPost('/saas/user/queryUser').then(res => {
        commit('SAVEINFO', res)
        return res
      })
    },
    getStatus({ commit }, data) {
      return fetchPost('/saas/customer/queryByCustomerNo', data).then(res => {
        console.log(res)
        commit('SETINFO', res)
        return res
      })
    },
    ChangeRoleApi({ }, data) {
      return fetchPost('/saas/user/updateMyRole', data)
    },
    SwitchTenantApi({ }, data) {
      return fetchPost('/saas/user/switchTenant', data)
    },
    ChangeTenantApi({ }, data) {
      return fetchPost('/saas/user/switchMyTenant', data)
    },
    sendVerifyCodeApi({ }, data) {
      return fetchPost('/saas/pub/smsVerifyCode/send', data)
      // return fetchPost('http://100.118.210.55:9999/tbp-order-owner-saas-web/saas/pub/smsVerifyCode/send', data)
    },
    checkPassOrgApi({ }, data) {
      return fetchPost('/saas/pub/password/checkPassOrg', data)
    },
    checkPassOrgMsgApi({ }, data) {
      return fetchPost('/saas/pub/password/checkPassOrgMsg', data)
    },
    resetApi({ }, data) {
      return fetchPost('/saas/pub/password/reset', data)
    },
    logoutApi() {
      return fetchPost('/upms/logout', {})
    },
    getInfo({ commit }, data) {
      commit('SAVEINFO', data)
    },
    logout() {
      return fetchPost('/logout', { interceptor: false }).then(res => res.data)
    },
    firstLandingReset({ }, data) {
      // 重置密码
      return fetchPost('/saas/pub/password/firstLandingReset', data)
    },
    delayValidTm({ }, data) {
      // 延长有效期
      return fetchPost('/saas/pub/password/delayValidTm', data)
    },
    register({ commit }, data) {
      // 注册
      return fetchGet('/upms/register', data)
      // return fetchGet('http://100.118.210.55:9999/tbp-order-owner-saas-web/upms/register', data)
    },
  }
}
